import styled from "styled-components";

// ==================== CONTENEDOR DE LA PÁGINA ====================
export const PortalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  background-color: #f0f4f8;
  font-family: var(--font-body, "Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif);
  color: #0f172a;
  box-sizing: border-box;
`;

// ==================== HEADER NAVBAR (ADAPTATIVO) ====================
export const PortalHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  padding: 0 24px;
  background-color: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  flex-shrink: 0;

  @media (max-width: 768px) {
    padding: 0 14px;
    height: 50px;
  }
`;

export const BrandSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  .brand-logo-icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .brand-title {
    font-family: var(--font-display, "Outfit", sans-serif);
    font-size: 1rem;
    font-weight: 800;
    color: #0f172a;
    letter-spacing: -0.01em;

    span.dot {
      color: #0f172a;
      margin: 0 4px;
    }

    .desktop-title {
      display: inline;
    }
    .mobile-title {
      display: none;
    }

    @media (max-width: 768px) {
      .desktop-title {
        display: none;
      }
      .mobile-title {
        display: inline;
      }
    }
  }
`;

export const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  .user-badge {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.813rem;
    font-weight: 700;
    color: #0f172a;
    text-transform: uppercase;
    letter-spacing: 0.01em;

    .avatar-icon-circle {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    @media (max-width: 768px) {
      span.name {
        display: none;
      }
    }
  }
`;

export const LogoutButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border: 1px solid #1e293b;
  color: #0f172a;
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 0.775rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);

  .btn-text {
    display: inline;
  }
  .btn-icon-only {
    display: none;
  }

  @media (max-width: 768px) {
    padding: 6px 8px;
    border: none;
    background: transparent;
    color: #1e3a8a;
    box-shadow: none;

    .btn-text {
      display: none;
    }
    .btn-icon-only {
      display: flex;
      align-items: center;
    }
  }

  &:hover {
    background-color: #fee2e2;
    border-color: #ef4444;
    color: #b91c1c;
  }
`;

// ==================== CONTENEDOR PRINCIPAL ====================
export const PortalMainContent = styled.main`
  flex: 1;
  max-width: 1240px;
  width: 100%;
  margin: 0 auto;
  padding: 14px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: 768px) {
    padding: 12px 14px;
    gap: 12px;
  }
`;

// ==================== TARJETA 1: DATOS DEL PACIENTE ====================
export const PatientInfoCardWrapper = styled.div`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
  padding: 14px 22px;
  display: grid;
  grid-template-columns: 1.2fr auto 1fr;
  align-items: center;
  gap: 20px;
  box-sizing: border-box;

  /* VISTA TABLET (769px - 1024px) */
  @media (min-width: 769px) and (max-width: 1024px) {
    grid-template-columns: 1.2fr auto 1fr;
    gap: 16px;
    padding: 12px 18px;
  }

  /* VISTA MOBILE (< 768px) */
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    padding: 14px 16px;
    gap: 10px;
  }
`;

export const DemographicsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;

  .patient-header-mobile {
    display: none;
  }

  .patient-name {
    font-family: var(--font-display, "Outfit", sans-serif);
    font-size: 1.05rem;
    font-weight: 800;
    color: #0f172a;
    margin: 0 0 2px 0;
    text-transform: uppercase;
    letter-spacing: -0.01em;
  }

  .demographic-row {
    margin: 0;
    font-size: 0.813rem;
    color: #334155;
    line-height: 1.35;

    strong {
      color: #0f172a;
      font-weight: 600;
    }
  }

  @media (max-width: 768px) {
    .desktop-only-name {
      display: none;
    }

    .patient-header-mobile {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 4px;

      .mobile-avatar-frame {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: #e0f2fe;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
      }

      .mobile-patient-name {
        font-family: var(--font-display, "Outfit", sans-serif);
        font-size: 0.95rem;
        font-weight: 800;
        color: #0f172a;
        text-transform: uppercase;
        line-height: 1.2;
      }
    }
  }
`;

export const ProgressGaugeSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  border-left: 1px solid #f1f5f9;
  border-right: 1px solid #f1f5f9;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileBottomInfoRow = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 8px;
    border-top: 1px solid #f1f5f9;
    gap: 12px;

    .mobile-gauge-group {
      display: flex;
      align-items: center;
      gap: 8px;

      .gauge-mini-box {
        width: 36px;
        height: 36px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
          transform: rotate(-90deg);
          width: 100%;
          height: 100%;
        }

        .mini-pct {
          position: absolute;
          font-size: 0.688rem;
          font-weight: 800;
          color: #1e3a8a;
        }
      }

      .cumplimiento-label {
        font-size: 0.813rem;
        font-weight: 600;
        color: #334155;
      }
    }

    .mobile-risk-pill {
      background-color: #f1f5f9;
      color: #334155;
      padding: 5px 12px;
      border-radius: 20px;
      font-size: 0.775rem;
      font-weight: 600;
      white-space: nowrap;
    }
  }
`;

export const GaugeContainer = styled.div`
  position: relative;
  width: 76px;
  height: 76px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg.gauge-svg {
    transform: rotate(-90deg);
    width: 100%;
    height: 100%;
  }

  .gauge-inner-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    pointer-events: none;

    .gauge-percentage {
      font-family: var(--font-display, "Outfit", sans-serif);
      font-size: 0.95rem;
      font-weight: 800;
      color: #1e3a8a;
      line-height: 1;
    }

    .gauge-avatar-icon {
      margin-top: 1px;
      color: #475569;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const RiskGroupContainer = styled.div`
  background-color: #f1f5f9;
  border-radius: 10px;
  padding: 10px 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  box-sizing: border-box;
  align-self: stretch;
  justify-content: center;

  @media (max-width: 768px) {
    display: none;
  }

  .risk-header {
    font-size: 0.813rem;
    font-weight: 700;
    color: #0f172a;
  }

  .risk-items-list {
    display: flex;
    flex-direction: column;
    gap: 2px;
    font-size: 0.813rem;
    color: #334155;

    .risk-item {
      display: flex;
      align-items: center;
      gap: 6px;

      span.bullet {
        color: #0f172a;
        font-size: 0.875rem;
      }
    }
  }
`;

// ==================== VISTAS RESPONSIVAS (TABLA VS TARJETAS) ====================
export const DesktopTableContainer = styled.div`
  display: block;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileCardsContainer = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .mobile-section-heading {
      font-family: var(--font-display, "Outfit", sans-serif);
      font-size: 1.05rem;
      font-weight: 800;
      color: #0f172a;
      margin: 2px 0 2px 0;
    }
  }
`;

// ==================== TARJETA 2 (DESKTOP/TABLET): TABLA DE ACTIVIDADES ====================
export const ActivitiesCardWrapper = styled.div`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;

  .card-header-bar {
    padding: 10px 18px;
    
    h3.card-title {
      font-family: var(--font-display, "Outfit", sans-serif);
      font-size: 0.95rem;
      font-weight: 700;
      color: #0f172a;
      margin: 0;
      letter-spacing: -0.01em;
    }
  }
`;

export const TableScrollWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const ActivitiesTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 0.813rem;

  thead tr {
    background-color: #ffffff;
    border-top: 1px solid #e2e8f0;
    border-bottom: 1px solid #e2e8f0;
  }

  th {
    padding: 7px 16px;
    font-weight: 700;
    color: #475569;
    text-transform: uppercase;
    font-size: 0.713rem;
    letter-spacing: 0.04em;
    white-space: nowrap;

    &.col-alert {
      text-align: center;
    }
  }

  tbody tr {
    border-bottom: 1px solid #f1f5f9;
    transition: background-color 0.1s ease;

    &:hover {
      background-color: #f8fafc;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  td {
    padding: 6px 16px;
    color: #0f172a;
    vertical-align: middle;
    line-height: 1.35;

    &.activity-name {
      font-weight: 500;
      color: #0f172a;
    }

    &.col-freq,
    &.col-date,
    &.col-result,
    &.col-status {
      color: #334155;
    }

    &.col-alert {
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 4px;
      padding-bottom: 4px;
    }
  }
`;

// ==================== TARJETAS MOBILE ACORDEÓN ====================
export const MobileActivityCard = styled.div`
  background: #ffffff;
  border: 1px solid ${({ $isOpen }) => ($isOpen ? "#cbd5e1" : "#e2e8f0")};
  border-radius: 12px;
  padding: 12px 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: column;
  transition: all 0.15s ease-in-out;

  .card-top-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    user-select: none;

    .activity-title {
      font-family: var(--font-display, "Outfit", sans-serif);
      font-size: 0.9rem;
      font-weight: 700;
      color: #0f172a;
      line-height: 1.25;
      flex: 1;
    }

    .header-right-actions {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-shrink: 0;

      .chevron-icon {
        color: #64748b;
        display: flex;
        align-items: center;
        transition: transform 0.2s ease;
        transform: ${({ $isOpen }) => ($isOpen ? "rotate(180deg)" : "rotate(0deg)")};
      }
    }
  }

  .card-details {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 0.8rem;
    color: #334155;
    margin-top: 10px;
    padding-top: 8px;
    border-top: 1px solid #f1f5f9;
    animation: fadeIn 0.18s ease-in-out;

    .detail-row {
      display: flex;
      align-items: baseline;
      gap: 4px;

      strong {
        color: #0f172a;
        font-weight: 600;
      }
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-3px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const MobileStatusPill = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px 10px;
  border-radius: 16px;
  font-size: 0.75rem;
  font-weight: 700;
  white-space: nowrap;

  background-color: ${({ $vigente }) => ($vigente ? "#10b981" : "#fef3c7")};
  color: ${({ $vigente }) => ($vigente ? "#ffffff" : "#b45309")};
`;

// ==================== LOGIN STYLES ====================
export const LoginWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f0f4f8;
  padding: 20px;
  box-sizing: border-box;
`;

export const LoginCard = styled.div`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  width: 100%;
  max-width: 400px;
  padding: 24px 20px;
  box-sizing: border-box;

  .login-header {
    text-align: center;
    margin-bottom: 18px;

    h1 {
      font-family: var(--font-display, "Outfit", sans-serif);
      font-size: 1.25rem;
      font-weight: 800;
      color: #1e3a8a;
      margin: 0 0 4px 0;
    }

    p {
      margin: 0;
      font-size: 0.775rem;
      color: #64748b;
    }
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .form-group {
    display: flex;
    flex-direction: column;
    gap: 3px;

    label {
      font-size: 0.75rem;
      font-weight: 700;
      color: #334155;
      text-transform: uppercase;
      letter-spacing: 0.02em;
    }

    input {
      height: 36px;
      padding: 0 10px;
      border: 1px solid #cbd5e1;
      border-radius: 6px;
      font-size: 0.85rem;
      font-family: var(--font-body, "Plus Jakarta Sans", sans-serif);
      color: #0f172a;
      transition: all 0.15s ease;

      &:focus {
        outline: none;
        border-color: #2563eb;
        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
      }
    }
  }

  .info-alert {
    background-color: #eff6ff;
    border: 1px solid #bfdbfe;
    border-radius: 6px;
    padding: 8px 10px;
    font-size: 0.775rem;
    color: #1e40af;
    line-height: 1.35;
  }

  .btn-submit {
    height: 36px;
    background-color: #1e3a8a;
    color: #ffffff;
    border: none;
    border-radius: 6px;
    font-size: 0.85rem;
    font-weight: 700;
    cursor: pointer;
    transition: background-color 0.15s ease;
    margin-top: 4px;

    &:hover {
      background-color: #1d4ed8;
    }

    &:disabled {
      background-color: #94a3b8;
      cursor: not-allowed;
    }
  }

  .btn-back {
    background: transparent;
    border: none;
    color: #64748b;
    font-size: 0.75rem;
    font-weight: 600;
    cursor: pointer;
    text-align: center;
    margin-top: 2px;

    &:hover {
      color: #0f172a;
      text-decoration: underline;
    }
  }
`;
